import { render, staticRenderFns } from "./KeepAliveRouteView.vue?vue&type=template&id=6d0d3951&scoped=true"
import script from "./KeepAliveRouteView.vue?vue&type=script&lang=js"
export * from "./KeepAliveRouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d3951",
  null
  
)

export default component.exports